import { StreamingPlayerTypography } from '@heardis/stream-contracts';
import NotesIcon from '../../elements/icons/NotesIcon';
import InfoContainer from './InfoContainer';
import classes from './NotesContainer.module.css';

type NotesContainerProps = {
  hideInfoContainer: () => void;
  backgroundColor: string;
  typography: StreamingPlayerTypography;
  notes: string;
};

function NotesContainer({ hideInfoContainer, backgroundColor, typography, notes }: NotesContainerProps) {
  return (
    <InfoContainer hideInfoContainer={hideInfoContainer} backgroundColor={backgroundColor} typography={typography}>
      <h2 className={classes.notesContainerTitle}>
        <NotesIcon />
        Track notes
      </h2>
      <p>{notes}</p>
    </InfoContainer>
  );
}

export default NotesContainer;
